import { FontFamily } from '@euler/components/typography/fonts';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import React, { memo, useMemo } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { TechnicianWorkloadItem, TechnicianWorkloadPayload } from './payloads';
import { useWidgetStyles } from './styles';

export const TechnicianWorkloadWidget = memo(
  ({ data }: { data: TechnicianWorkloadPayload }) => {
    const { rpx } = useResponsiveContext();
    const ws = useWidgetStyles();
    const s = useMemo(
      () =>
        StyleSheet.create({
          workloadRow: {
            flexDirection: 'row',
            alignItems: 'center',
            marginBottom: rpx(6),
          },
          workloadName: {
            width: rpx(60),
            fontSize: rpx(12),
            fontFamily: FontFamily.NotoSans.Regular,
            color: '#475569',
          },
          workloadBarBg: {
            flex: 1,
            height: rpx(8),
            backgroundColor: '#E2E8F0',
            borderRadius: rpx(4),
            marginHorizontal: rpx(8),
            overflow: 'hidden',
          },
          workloadBarFill: {
            height: rpx(8),
            backgroundColor: '#3B82F6',
            borderRadius: rpx(4),
          },
          workloadCount: {
            width: rpx(36),
            fontSize: rpx(11),
            fontFamily: FontFamily.NotoSans.Regular,
            color: '#64748B',
            textAlign: 'right',
          },
        }),
      [rpx],
    );

    const items: TechnicianWorkloadItem[] = Array.isArray(data)
      ? data
      : data.items ?? [];

    const maxTotal = Math.max(
      ...items.map(
        x => (x.inProgress ?? 0) + (x.pending ?? 0) + (x.finishedToday ?? 0),
      ),
      1,
    );

    return (
      <View style={ws.card}>
        <Text style={[ws.title, { marginBottom: rpx(8) }]}>技师工作量</Text>
        {items.map((item, i) => {
          const active = (item.inProgress ?? 0) + (item.pending ?? 0);
          const total = active + (item.finishedToday ?? 0);
          return (
            <View key={i} style={s.workloadRow}>
              <Text style={s.workloadName}>{item.name}</Text>
              <View style={s.workloadBarBg}>
                <View
                  style={[
                    s.workloadBarFill,
                    {
                      width: `${Math.min((total / maxTotal) * 100, 100)}%`,
                      backgroundColor: active > 0 ? '#F59E0B' : '#3B82F6',
                    },
                  ]}
                />
              </View>
              <Text style={s.workloadCount}>
                {active}/{total}
              </Text>
            </View>
          );
        })}
      </View>
    );
  },
);
